export default function formikFieldToAntProps(errors, touched, field, def = 'validating') {
  return {
    validateStatus: touched[field] && errors[field] ? 'error' : undefined,
    help: touched[field] && errors[field] ? errors[field] : null,
  };
}
